import {Component, OnInit} from '@angular/core';
import {EventService} from '../../../_services/event.service';
import {StudentService} from '../../../_services/student.service';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {TokenStorageService} from '../../../_services/token-storage.service';
import * as moment from 'moment';
import {ProfileService} from '../../../_services/profile.service';

declare let $: any;

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.css']
})
export class CommentsComponent implements OnInit {

  commentForm!: UntypedFormGroup;

  drivingComments: any[] = [];
  userId: any = 1;

  student: any;

  studentId = '';

  messageError = '';

  isPhone = false;
  isMonitor = false;
  isStudent = false;

  constructor(
    private fb: UntypedFormBuilder,
    private eventService: EventService,
    private tokenStorageService: TokenStorageService,
    private studentService: StudentService,
    private profileService: ProfileService,
    private router: Router
  ) {
  }

  ngOnInit(): void {

    this.isPhone = screen.width < 450;

    this.isStudent =
      this.router.url.includes('/my-book-comments');

    if (!this.isStudent) {
      this.studentId =
        this.router.url.split('/')[2];
    }

    const user =
      this.tokenStorageService.getUser();

    this.userId = user.id;

    this.isMonitor =
      user.roles.includes('ROLE_SUPER_ADMIN') ||
      user.roles.includes('ROLE_MONITOR');

    this.commentForm = this.initForm();

    this.loadStudent();
  }

  private loadStudent(): void {

    if (this.isStudent) {

      this.profileService.getMyProfile().subscribe(
        data => {
          this.student = data;

          this.getMyDrivingComments();
        },
        error => {
          console.log(error);
        }
      );

      return;
    }

    this.studentService
      .getStudentsById(this.studentId)
      .subscribe(
        data => {
          this.student = data;

          this.getStudentDrivingComments(
            this.studentId
          );
        },
        error => {
          console.log(error);
        }
      );
  }

  validComment(): void {

    if (this.commentForm.invalid) {
      return;
    }

    this.studentService
      .saveDrivingComment(
        this.commentForm.value
      )
      .subscribe(
        () => {

          $('#drivingCommentModal')
            .modal('hide');

          this.reloadComments();
        },
        error => {
          console.log(error);
        }
      );
  }

  editComment(
    id: string,
    date: Date,
    comment: string
  ): void {

    this.commentForm = this.fb.group({

      id: [
        id,
        Validators.required
      ],

      date: [
        moment
          .utc(date || new Date())
          .format('YYYY-MM-DD'),
        Validators.required
      ],

      userId: [
        this.userId,
        Validators.required
      ],

      studentId: [
        this.studentId,
        Validators.required
      ],

      comment: [
        comment,
        Validators.required
      ]

    });

    $('#drivingCommentModal')
      .modal('show');
  }

  addComment(): void {

    this.commentForm =
      this.initForm();

    $('#drivingCommentModal')
      .modal('show');
  }

  getStudentDrivingComments(
    studentId: string
  ): void {

    this.studentService
      .getStudentDrivingComments(studentId)
      .subscribe(
        (data: any) => {

          this.drivingComments =
            Array.isArray(data)
              ? data
              : [];

        },
        err => {
          this.messageError =
            err.error?.message ||
            'Une erreur est survenue.';
        }
      );
  }

  getMyDrivingComments(): void {

    this.profileService
      .getMyDrivingComments()
      .subscribe(
        (data: any) => {

          this.drivingComments =
            Array.isArray(data)
              ? data
              : [];

        },
        err => {
          this.messageError =
            err.error?.message ||
            'Une erreur est survenue.';
        }
      );
  }

  private reloadComments(): void {

    if (this.isStudent) {
      this.getMyDrivingComments();
      return;
    }

    this.getStudentDrivingComments(
      this.studentId
    );
  }

  private initForm(): UntypedFormGroup {

    return this.fb.group({

      id: null,

      date: [
        moment
          .utc(new Date())
          .format('YYYY-MM-DD'),
        Validators.required
      ],

      userId: [
        this.userId,
        Validators.required
      ],

      studentId: [
        this.studentId,
        Validators.required
      ],

      comment: [
        null,
        Validators.required
      ]

    });
  }

  get sortedDrivingCommentsDesc(): any[] {

    return [
      ...(this.drivingComments || [])
    ].sort(
      (a, b) =>
        new Date(b.date).getTime() -
        new Date(a.date).getTime()
    );
  }

  get totalSessions(): number {

    return this.drivingComments?.length || 0;
  }

  get studentInitials(): string {

    if (!this.student) {
      return '';
    }

    const firstname =
      this.student.firstname || '';

    const lastname =
      this.student.lastname || '';

    return (
      firstname.charAt(0) +
      lastname.charAt(0)
    ).toUpperCase();
  }

  get lastCommentDate(): Date | null {

    if (!this.sortedDrivingCommentsDesc.length) {
      return null;
    }

    return this.sortedDrivingCommentsDesc[0].date;
  }
}
